import cx from 'classnames'
import _ from 'lodash'

import './styles.scss'

interface ButtonProps {
  label: string
  grey?: boolean
  teal?: boolean
  purple?: boolean
  long?: boolean
  children: JSX.Element
  props?: object
}

export function Button ({ label, grey, teal, purple, long, children, ...rest }: ButtonProps): JSX.Element {
  return (
    <button
      type='button'
      name='nh-button'
      className={cx('nh-raised-button', {
        grey,
        long,
        teal,
        purple
      })}
      {...rest}
    >
      {children}
      {_.toUpper(label)}
    </button>
  )
}
